import React, { PureComponent } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import moment from 'moment/moment';
import i18n from '../../../i18next';

export default class StatisticsLineChart extends PureComponent {
   
 formatData = (type, serviceData) => {
  if(serviceData) {
      let data;
      if(type === 'restaurantPaymentTypes') {

        const restaurantPaymentTypes = serviceData.map(type => type.paymentTypeSummary);
        const fromDates = serviceData.map(date => date.fromDate);
        const toDates = serviceData.map(date => date.toDate);

        return data = restaurantPaymentTypes.map((item, i) => {
          moment.defaultFormat = "DD.MM.YYYY HH:mm";
          return {
              name: `${moment(fromDates[i], moment.defaultFormat).format('DD/MM')}-${moment(toDates[i], moment.defaultFormat).format('DD/MM')}`,
              [i18n.t(`common:paymentTypes.creditCard`)]: item[0].typeIndex === 1 ? item[0].count : null,
              [i18n.t(`common:paymentTypes.cash`)]: item[1].typeIndex === 2 ? item[1].count : null,
              [i18n.t(`screens:restaurantsMainContainer.loyalty`)]: item[2].typeIndex === 3 ? item[2].count : null,
              [i18n.t(`screens:restaurantInsightScreen.giftCard`)]: item[3].typeIndex === 4 ? item[3].count : null,
              //amt: 2400
          }
        }) 
      } else if(type === 'restaurantSourceTypes') {

        const restaurantSourceTypes = serviceData.map(type => type.sourceTypeSummary);
        const fromDates = serviceData.map(date => date.fromDate);
        const toDates = serviceData.map(date => date.toDate);

       return data = restaurantSourceTypes.map((item, i) => {
          moment.defaultFormat = "DD.MM.YYYY HH:mm";
          return {
              name: `${moment(fromDates[i], moment.defaultFormat).format('DD/MM')}-${moment(toDates[i], moment.defaultFormat).format('DD/MM')}`,
              Web: item[0].typeIndex === 1 ? item[0].count : null,
              'Web IOS': item[1].typeIndex === 2 ? item[1].count : null,
              'Web Android': item[2].typeIndex === 3 ? item[2].count : null,
              'App IOS': item[3].typeIndex === 4 ? item[3].count : null,
              'App Android': item[4].typeIndex === 5 ? item[4].count : null,
              //amt: 2400
          }
        }) 
      } else if(type === 'restaurantOrderTypes') {

        const restaurantOrderTypes = serviceData.map(type => type.orderTypeSummary);
        const fromDates = serviceData.map(date => date.fromDate);
        const toDates = serviceData.map(date => date.toDate);

        return data = restaurantOrderTypes.map((item, i) => {
          moment.defaultFormat = "DD.MM.YYYY HH:mm";
          return {
            name: `${moment(fromDates[i], moment.defaultFormat).format('DD/MM')}-${moment(toDates[i], moment.defaultFormat).format('DD/MM')}`,
            [i18n.t(`screens:restaurantsMainContainer.delivery`)]: item[0].typeIndex === 1 ? item[0].count : null,
            [i18n.t(`screens:restaurantsMainContainer.collection`)]: item[1].typeIndex === 2 ? item[1].count : null,
            [i18n.t(`screens:restaurantsMainContainer.curbside`)]: item[2].typeIndex === 4 ? item[2].count : null,
            [i18n.t(`screens:restaurantsMainContainer.instore`)]: item[3].typeIndex === 5 ? item[3].count : null
          }

        })
      }
    }
  }

  renderRestaurantPaymentTypesChart = () => {
    return(
      <ResponsiveContainer width="95%" height="60%">
        <LineChart
          width={600}
          height={300}
          data={this.formatData(this.props.type, this.props.summary)}
          margin={{
            top: 10,
            right: 30,
            left: 10,
            bottom: 10,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" fontSize="10px"/>
          <YAxis fontSize="10px"/>
          <Tooltip />
          <Legend />
          <Line type="monotone" dataKey={i18n.t(`common:paymentTypes.creditCard`)} stroke="#8884d8" activeDot={{ r: 8 }} strokeWidth={1.5}/>
          <Line type="monotone" dataKey={i18n.t(`common:paymentTypes.cash`)} stroke="#82ca9d" activeDot={{ r: 8 }} strokeWidth={1.5}/>
          <Line type="monotone" dataKey={i18n.t(`screens:restaurantsMainContainer.loyalty`)} stroke="#C71585" activeDot={{ r: 8 }} strokeWidth={1.5}/>
          <Line type="monotone" dataKey={i18n.t(`screens:restaurantInsightScreen.giftCard`)} stroke="#ADFF2F" activeDot={{ r: 8 }} strokeWidth={1.5}/>
        </LineChart>
      </ResponsiveContainer>
    )
  }

  rendeRrestaurantSourceTypesChart = () => {
    return(
      <ResponsiveContainer width="95%" height="60%">
        <LineChart
            width={600}
            height={300}
            data={this.formatData(this.props.type, this.props.summary)}
            margin={{
              top: 10,
              right: 30,
              left: 10,
              bottom: 10,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" fontSize="10px"/>
            <YAxis fontSize="10px"/>
            <Tooltip />
            <Legend />
            <Line type="monotone" dataKey="Web" stroke="#8884d8" activeDot={{ r: 8 }} strokeWidth={1.5}/>
            <Line type="monotone" dataKey="Web IOS" stroke="#82ca9d" activeDot={{ r: 8 }} strokeWidth={1.5}/>
            <Line type="monotone" dataKey="Web Android" stroke="#C71585" activeDot={{ r: 8 }} strokeWidth={1.5}/>
            <Line type="monotone" dataKey="App IOS" stroke="#ADFF2F" activeDot={{ r: 8 }} strokeWidth={1.5}/>
            <Line type="monotone" dataKey="App Android" stroke="#708090" activeDot={{ r: 8 }} strokeWidth={1.5}/>
        </LineChart>
      </ResponsiveContainer>
    )
  }

  renderRestaurantOrderTypes = () => {
    return(
      <ResponsiveContainer width="95%" height="60%">
        <LineChart
            width={600}
            height={300}
            data={this.formatData(this.props.type, this.props.summary)}
            margin={{
              top: 10,
              right: 30,
              left: 10,
              bottom: 10,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" fontSize="10px"/>
            <YAxis fontSize="10px"/>
            <Tooltip />
            <Legend />
            <Line type="monotone" dataKey={i18n.t(`screens:restaurantsMainContainer.delivery`)} stroke="#8884d8" activeDot={{ r: 8 }} strokeWidth={1.5}/>
            <Line type="monotone" dataKey={i18n.t(`screens:restaurantsMainContainer.collection`)} stroke="#82ca9d" activeDot={{ r: 8 }} strokeWidth={1.5}/>
            <Line type="monotone" dataKey={i18n.t(`screens:restaurantsMainContainer.curbside`)} stroke="#ADFF2F" activeDot={{ r: 8 }} strokeWidth={1.5}/>
            <Line type="monotone" dataKey={i18n.t(`screens:restaurantsMainContainer.instore`)} stroke="#708090" activeDot={{ r: 8 }} strokeWidth={1.5}/>
        </LineChart>
      </ResponsiveContainer>
    )
  }

  renderRestaurantTypesCharts = () => {
    if(this.props.type === 'restaurantPaymentTypes') {
      return (
        this.renderRestaurantPaymentTypesChart()
       )
    } else if(this.props.type === 'restaurantSourceTypes') {
      return(
       this.rendeRrestaurantSourceTypesChart()
      )
    } else if(this.props.type === 'restaurantOrderTypes') {
      return(
        this.renderRestaurantOrderTypes()
      )
    }
  }

  render() {
      return (
        this.renderRestaurantTypesCharts()
      )
    }
}



// WEBPACK FOOTER //
// ./src/components/restaurants/restaurantInsight/StatisticsLineChart.js